import React from "react";
import CollapseSection from "../../../collapse/CollapseSection";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../../input/TextInput";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";
import SelectApiInput from "../../../input/SelectApiInput";
import PasswordInput from "../../../input/PasswordInput";
import CheckboxInput from "../../../input/CheckboxInput";
import NumberInput from "../../../input/NumberInput";

interface IInfoSection {
  isEdit?: boolean;
  control?: Control<any, any>;
  errors?: FieldErrors<any>;
  register?: UseFormRegister<FieldValues> | undefined;
  watch?: UseFormWatch<FieldValues> | undefined;
}

function InfoSection({
  isEdit,
  errors,
  control,
  register,
  watch,
}: IInfoSection) {
  const autoCreateUser = watch?.("auto_create_user");

  return (
    <CollapseSection show title="Thông tin chung">
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 7 }}>
          <Stack gap={2}>
            <TextInput
              readOnly={isEdit}
              required
              name="email"
              label="Tài khoản"
              labelWidth="25%"
              placeholder="email@gmail.com"
              register={register}
              errorMessage={errors?.email?.message as string}
            />
            <TextInput
              label="Tên người dùng"
              labelWidth="25%"
              placeholder="Tên người dùng"
              name="name"
              required
              register={register}
              errorMessage={errors?.name?.message as string}
            />
            <NumberInput
              label="Cấp thành viên"
              labelWidth="25%"
              placeholder="Nhập cấp thành viên"
              name="level"
              register={register}
            />
            <Controller
              control={control}
              name="usergroup"
              render={({ field: { onChange, value } }) => (
                <SelectApiInput
                  label="Nhóm"
                  labelWidth="25%"
                  apiCode="usergroup"
                  placeholder="Chọn nhóm người dùng"
                  searchFields={["group_name"]}
                  value={value}
                  onChange={onChange}
                  getOptionLabel={(option) => option.group_name}
                  checkEqual={(value, option) => value?._id === option?._id}
                />
              )}
            />
            <TextInput
              multiline
              label="Ghi chú"
              labelWidth="25%"
              placeholder="Nhập ghi chú"
              name="dien_giai"
              register={register}
            />
            {!!autoCreateUser && (
              <PasswordInput
                label="Mật khẩu"
                labelWidth="25%"
                placeholder="Mật khẩu"
                name="password"
                register={register}
              />
            )}
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 5 }}>
          <Stack gap={2}>
            <Controller
              control={control}
              name="admin"
              render={({ field: { onChange, value } }) => (
                <CheckboxInput
                  label="Là người quản trị"
                  checked={value || false}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="status"
              render={({ field: { onChange, value } }) => (
                <CheckboxInput
                  label="Còn hoạt động"
                  checked={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="cancel"
              render={({ field: { onChange, value } }) => (
                <CheckboxInput
                  label="Khóa tạm thời"
                  checked={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="auto_create_user"
              render={({ field: { onChange, value } }) => (
                <CheckboxInput
                  label="Tạo người dùng nếu người dùng chưa được tạo"
                  checked={value || false}
                  onChange={onChange}
                />
              )}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default InfoSection;
